import { useState, useEffect, useContext } from "react";
import styled, { keyframes } from "styled-components";
import { BsFillPencilFill } from "react-icons/bs";
import { IoRestaurantOutline } from "react-icons/io5";
import API from "../../API";
import AuthContext from "../../context/AuthContext";
import ModalHeaderServices from "./Modal";

export default function Services() {
  const [modalShow, setModalShow] = useState(false);
  const [services,  setServices]  = useState([]);
  const { user }                  = useContext(AuthContext);

  useEffect(() => { refreshServices(); }, []);

  const refreshServices = () => {
    API.get("api/Services/")
      .then((res) => setServices(res.data))
      .catch(console.error);
  };

  const handleMessageChange = (event) => {
    if (event.target.id === "title")       services[0].title       = event.target.value;
    if (event.target.id === "description") services[0].description = event.target.value;
  };

  const handlesubmit = () => {
    if (services[0].id) {
      API.put(`api/Services/${services[0].id}/`, services[0]).then(() => refreshServices());
      return;
    }
    API.post("api/Services/", services).then(() => refreshServices());
  };

  if (!services.length) return null;

  const service = services[0];

  return (
    <Section id="services">
      <Ornament>◆</Ornament>

      <ServiceHeader>
        <ServiceEyebrow>
          <IoRestaurantOutline />
          <span>Notre établissement</span>
        </ServiceEyebrow>

        <TitleRow>
          <ServiceTitle>{service.title}</ServiceTitle>
          {user && (
            <EditBtn onClick={() => setModalShow(true)} title="Modifier">
              <BsFillPencilFill />
            </EditBtn>
          )}
        </TitleRow>

        <GoldBar />

        <ServiceDescription>
          {service.description}
          {user && (
            <EditInlineBtn onClick={() => setModalShow(true)} title="Modifier">
              <BsFillPencilFill />
            </EditInlineBtn>
          )}
        </ServiceDescription>
      </ServiceHeader>

      <ModalHeaderServices
        show={modalShow}
        onHide={() => setModalShow(false)}
        handleSubmit={() => handlesubmit()}
        activeItem={service}
        onChange={handleMessageChange}
      />
    </Section>
  );
}

/* ─── Keyframes ─── */
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ─── Styled Components ─── */

const Section = styled.section`
  padding: 5rem 5vw 4rem;
  background: var(--bg-surface);
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, var(--primary), transparent);
  }
  &::after {
    content: "";
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, var(--border), transparent);
  }
`;

const Ornament = styled.div`
  font-size: 0.55rem;
  color: var(--primary);
  letter-spacing: 0.3em;
  margin-bottom: 1.5rem;
  opacity: 0.6;
`;

const ServiceHeader = styled.div`
  max-width: 720px;
  margin: 0 auto;
  animation: ${fadeUp} 0.7s ease both;
`;

const ServiceEyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-script);
  font-size: 1rem;
  color: var(--primary);
  font-style: italic;
  letter-spacing: 0.1em;
  margin-bottom: 0.75rem;

  svg { font-size: 1rem; }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
`;

const ServiceTitle = styled.h2`
  font-family: var(--font-heading);
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  color: var(--cream);
  font-weight: 500;
  line-height: 1.2;
`;

const GoldBar = styled.div`
  width: 50px;
  height: 2px;
  background: linear-gradient(to right, transparent, var(--primary), transparent);
  margin: 1rem auto;
`;

const ServiceDescription = styled.p`
  font-size: clamp(0.95rem, 2vw, 1.1rem);
  color: var(--cream-dim);
  line-height: 1.9;
  letter-spacing: 0.03em;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const EditBtn = styled.button`
  background: none;
  border: 1px solid var(--border);
  color: var(--primary);
  font-size: 0.85rem;
  width: 30px;
  height: 30px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
  flex-shrink: 0;

  &:hover { background: var(--primary-glow); }
`;

const EditInlineBtn = styled(EditBtn)`
  width: 24px;
  height: 24px;
  font-size: 0.72rem;
  flex-shrink: 0;
`;
